var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 389,
    viewBox: "0 0 647 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.816 289.727C95.3697 264.157 31.0832 268.058 3.12078 273.205C22.8153 270.462 67.0807 268.321 86.5857 281.7C106.091 295.078 243.232 353.52 309.364 381.069L318.525 381.271C316.347 369.34 286.823 355.961 272.334 350.764C238.431 341.072 162.263 315.297 128.816 289.727Z",
    fill: "url(#paint0_linear_723_839)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5211 87.5497L15.0258 33.2632C101.331 17.6095 132.787 28.5474 137.727 35.973C195.052 84.2421 203.784 124.269 200.984 138.249C197.554 148.89 179.596 161.5 135.209 126.82C90.8228 92.1391 35.5895 86.1895 13.5211 87.5497Z",
    fill: "url(#paint1_linear_723_839)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M600.059 13.6712L393.015 8.66489C351.937 7.75774 347.911 31.7616 351.033 43.877C355.619 55.3595 380.252 80.9719 442.095 91.5609C503.938 102.15 548.584 142.542 563.177 161.414C574.938 175.124 602.464 202.545 618.48 202.544C634.497 202.543 640.963 189.146 642.194 182.448L635.866 51.9007C634.385 35.7272 606.966 13.9715 600.059 13.6712Z",
    fill: "url(#paint2_linear_723_839)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.66 253.831L126.001 298.311L70.8866 297.094L99.66 253.831Z",
    fill: "#F68500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M578.834 127.394L605.175 171.875L550.06 170.658L578.834 127.394Z",
    fill: "#F68500"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_839",
    x1: 162.357,
    y1: 271.893,
    x2: 160.019,
    y2: 377.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_723_839",
    x1: 178.24,
    y1: 114.689,
    x2: 19.7833,
    y2: 72.6573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_723_839",
    x1: 483.552,
    y1: 23.0803,
    x2: 630.431,
    y2: 172.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A00CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientCard2);
export default __webpack_public_path__ + "static/media/gradient-card-2.702328eb0a9618c518d9e007d03e6546.svg";
export { ForwardRef as ReactComponent };